export default __webpack_public_path__ + "static/image3-00c97d89455ac9ce9923696e15329718.webp";